import { RemoveSolidIcon } from '@pmi/dsm-react/dist/components/icons';
import { Form } from 'react-bootstrap';
import { ProductBundleOption } from '../models';

export type BundleOptionSelections = Record<string, string>;

interface BundleOptionSelectorProps {
  selectableBundleOptions: ProductBundleOption[];
  selections: BundleOptionSelections;
  onChange: (selections: BundleOptionSelections) => void;
  showErrors: boolean;
  disabled?: boolean;
}

const errorMsg = (msg: string) => (
  <div className="invalid-feedback d-block">
    <div className="d-flex">
      <span className="d-block me-1">
        <RemoveSolidIcon fontSize="sm" />
      </span>
      <span className="d-block">{msg}</span>
    </div>
  </div>
);

export default function BundleOptionSelector({
  selectableBundleOptions,
  selections,
  onChange,
  showErrors,
  disabled = false,
}: BundleOptionSelectorProps) {
  return (
    <div className="d-block mt-3">
      {selectableBundleOptions.map((bundleOption) => {
        const fieldName = String(bundleOption.id);
        const value = selections[fieldName] ?? '';
        const selectOption = bundleOption.selectOption ?? '';
        const hasError = showErrors && !value;

        return (
          <div className="mb-3" key={fieldName}>
            <Form.Group
              controlId={`bundleOptionSelector-${fieldName}`}
              className={hasError ? 'is-invalid' : undefined}
            >
              <Form.Label>
                Select {selectOption} for course materials{' '}
                <span className="text-danger">*</span>
              </Form.Label>
              <Form.Select
                aria-label={`Select ${selectOption}`}
                className={`dsm-input-field__form-control cursor-pointer ${
                  hasError ? 'dsm-input-field__form-control--error' : ''
                }`}
                value={value}
                disabled={disabled}
                onChange={(e) => {
                  onChange({
                    ...selections,
                    [fieldName]: e.target.value,
                  });
                }}
              >
                <option key="" value="" className="dsm-menu__label">
                  Select
                </option>
                {bundleOption.productLinks.map((link) => (
                  <option
                    className="dsm-menu__label break-all-words mw-100"
                    key={link.sku}
                    value={link.sku}
                  >
                    {link.value}
                  </option>
                ))}
              </Form.Select>
              {hasError
                ? errorMsg(`Selecting a ${selectOption} is required`)
                : null}
            </Form.Group>
          </div>
        );
      })}
    </div>
  );
}
